import {
  ArticleCard,
  ArticleCardBadge,
  ArticleCardBody,
  ArticleCardExcerpt,
  ArticleCardHeader,
  ArticleCardImage,
  ArticleCardLayout,
  ArticleCardMediaLink,
  ArticleCardSummary,
  ArticleCardTitle,
  ArticleCardTitleLink,
  type ArticleCardVariant,
} from '@vs-shop/commerce-ui/articleCard';
import { Badge } from '@vs-shop/ui/badge';
import { ImageMissingPlaceholder } from '@vs-shop/ui/imageMissingPlaceholder';
import { coalesceNonEmpty } from '@vs-shop/domain/string/coalesceNonEmpty';

import { resolveImageUrl } from '@vs-shop/engine/image/resolveImageUrl';
import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../../utils/intl';

import Link from '@vs-shop/image-link/Link';
import { ArticleInfoHeader } from '../ArticleInfoHeader';
import { TextLink } from '@vs-shop/ui/textLink';

import type { ArticleIndex } from '../../../../../effect/schema/openapi/backend';
import { ImageFilter } from '@vs-shop/engine/image/ImageFilter';

/*
 * TODO
 *   1) article read time
 * */

type Props = {
  article: ArticleIndex;
  variant: ArticleCardVariant;
};

export default function ArticlePreview({ variant, article }: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  const readTime = 5;

  const author = article.authors[0] ?? null;

  const imagePathAbstract = article.thumbnailImageAbstract ?? null;
  const imagePath =
    imagePathAbstract !== null
      ? resolveImageUrl(imagePathAbstract, ImageFilter.blog_article_thumb)
      : '';

  const title = coalesceNonEmpty(article.metaTitle, article.title) ?? '';

  return (
    <ArticleCard variant={variant}>
      <ArticleCardLayout>
        <ArticleCardMediaLink variant={variant} href={article.routerUrl} title={title}>
          {imagePathAbstract !== null ? (
            <ArticleCardImage src={imagePath} alt={title} preload width={457} height={344} />
          ) : (
            <ImageMissingPlaceholder />
          )}
          <ArticleCardBadge render={<Badge variant="primary" />}>
            {article.section.name}
          </ArticleCardBadge>
        </ArticleCardMediaLink>

        <ArticleCardBody variant={variant}>
          <ArticleCardHeader>
            <ArticleCardTitleLink href={article.routerUrl} title={title}>
              <ArticleCardTitle variant={variant}>{article.title}</ArticleCardTitle>
            </ArticleCardTitleLink>
            <ArticleInfoHeader
              publishedAt={article.publishedAt}
              author={author}
              readTime={readTime}
            />
          </ArticleCardHeader>

          <ArticleCardSummary variant={variant}>
            <ArticleCardExcerpt variant={variant}>{article.description}</ArticleCardExcerpt>
            <TextLink render={<Link href={article.routerUrl} />}>
              {intl.formatMessage({
                id: 'component.server.page.article.overview.articlePreview.readFullArticle',
                defaultMessage: 'Zobrazit celý článek',
              })}
            </TextLink>
          </ArticleCardSummary>
        </ArticleCardBody>
      </ArticleCardLayout>
    </ArticleCard>
  );
}
